import {Link} from 'react-router-dom';
import {DoubleLine} from "../Labels";


const PortfolioLink = ({portfolio})=>{
    return (
        <Link to={`/portfolio/${portfolio.id}`}>
            <DoubleLine
                title={portfolio.name}
                text={'View This Portfolio'}
            />
        </Link>
    )
}

export default PortfolioLink;